module.exports = __webpack_public_path__ + "static/img/logo_black.88d5917.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo_black.png
// module id = OKYU
// module chunks = 27